import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, Button, Image, TextField, AppProvider, PageActions, Page, Card } from '@shopify/polaris';
// import tookanLogo from 'tookan-1.png';

const propTypes = {
  apiKey: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleApiKeyChange: PropTypes.func.isRequired,
};

const defaultProps = {

}


const TookanApiForm = (props) => (
  <div>
    <Card sectioned>
      <div className="mb10">
        <img src={ imagePaths.tookanLogo } />
  
        <p className="text center mt10">
          { I18n.t("tookan_rule.info.integration_info") }
        </p>
      </div>
  
      <Form onSubmit={ props.handleSubmit } >
        <TextField
          type="password"
          name="tookan_api_key"
          label= { I18n.t("activerecord.attributes.shop.tookan_api_key") }
          placeholder="a31c052***********"
          onChange={(value, id) => props.handleApiKeyChange(value) }
          value={ props.apiKey } />

        {/* <Button type='button' onClick={() => history.back()}>
          { I18n.t("actions.back").toUpperCase() }
        </Button> */}
      </Form>
    </Card>
    <PageActions 
      primaryAction={{
        onAction: props.handleSubmit,
        loading: props.loading,
        content: I18n.t("actions.save")
      }}
    />
  </div>
);

TookanApiForm.propTypes = propTypes;
TookanApiForm.defaultProps = defaultProps;

export default TookanApiForm;